import { useRefreshInboxMutation } from "@qw/graphql";
import { parseError } from "@qw/qw-common";
import { Button, cn, Icon, Tooltip, TooltipContent, TooltipTrigger, useToast } from "@qw/ui";
import { useCallback } from "react";

type InboxRefreshButtonProps = {
  onRefreshComplete: () => Promise<unknown> | unknown;
};

export const InboxRefreshButton = ({ onRefreshComplete }: InboxRefreshButtonProps) => {
  const { toast } = useToast();
  const [refreshInbox, { loading: isRefreshingInbox }] = useRefreshInboxMutation();

  const handleRefreshInbox = useCallback(async () => {
    try {
      await refreshInbox();
      await onRefreshComplete();
    } catch (error) {
      toast({
        title: "Failed to refresh inbox",
        description: parseError(error as Parameters<typeof parseError>[0]),
        variant: "destructive",
      });
    }
  }, [onRefreshComplete, refreshInbox, toast]);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          display="icon"
          aria-label="Refresh inbox"
          className="size-6 text-muted-foreground hover:text-foreground"
          disabled={isRefreshingInbox}
          onClick={handleRefreshInbox}
        >
          <Icon icon="refresh" className={cn(isRefreshingInbox && "animate-spin")} />
        </Button>
      </TooltipTrigger>
      <TooltipContent>Refresh inbox</TooltipContent>
    </Tooltip>
  );
};
